/**
 * One table and one form treatment for the whole app.
 *
 * These are class strings, not components: every screen renders plain semantic
 * `<table>` / `<select>` markup and borrows the same spacing, so three screens
 * built at different times still look like one tool. Dense on purpose — HROps
 * is a working list, not a dashboard.
 */

export const table = "w-full border-collapse text-sm";
export const th = "text-fg-muted border-border border-b px-3 py-2 text-left text-xs font-medium";
export const td = "border-border-subtle border-b px-3 py-2 align-top";

/** Secondary line inside a cell: the UPN under a name, the zone under a time. */
export const subText = "text-fg-muted text-xs";

/** Native controls that are not worth a design-system wrapper. */
export const control = "border-border bg-bg text-fg rounded border px-2 py-1 text-sm";

/** The lead paragraph under every page heading. */
export const lead = "text-fg-muted mt-1 max-w-prose text-sm";
